import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function taxa(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@taxa/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@taxa/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@taxa/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@taxa/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@taxa/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@taxa/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}